import React from 'react';
import { useBlueprint } from '../../contexts/BlueprintContext';
import { BookOpen } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';

const BlueprintToggle = ({ className = '', variant = 'ghost', darkMode = false }) => {
  const { isOpen, toggleBlueprint } = useBlueprint();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={variant}
            size="icon"
            onClick={toggleBlueprint}
            className={`h-8 w-8 relative ${isOpen ? 'bg-[#70170F]/10 text-[#70170F]' : ''} ${darkMode ? 'text-[#E5E2DD] hover:bg-[#1A1A1A]' : ''} ${className}`}
            data-testid="blueprint-toggle"
            title="Toggle Blueprint Help"
          >
            <BookOpen className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={1.5} />
            {isOpen && (
              <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-[#70170F] rounded-full" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent className={darkMode ? 'bg-[#1A1A1A] text-[#E5E2DD] border-[#2A2A2A]' : ''}>
          <p>{isOpen ? 'Close Blueprint (Esc)' : 'Open Blueprint Help'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default BlueprintToggle;
